import styled, { spacing } from "@rentiohq/web-theme";
import { rem } from "polished";

export const Address = styled.p`
  margin: ${spacing("loose")} 0 0;
`;

export const Body = styled.p`
  margin: ${spacing("tight")} 0 0;
  line-height: 1.5;
`;

export const Error = styled.div`
  margin: ${spacing("loose")} 0 0;
`;

export const Actions = styled.div`
  margin-top: ${spacing("extraLoose")};
`;

/** Rentmatch's logo, in the place and at the width of Rentio's (StyledAuthLogo). */
export const RentmatchLogo = styled.img`
  display: block;
  width: ${({ theme }) => rem("200px", theme.baseFontSize)};
  margin: ${spacing("extraLoose")} auto;
  margin-bottom: ${spacing("loose")};
`;
